import { computed } from 'vue';
import { useSessionStore } from '@/stores/session';
import { getLocaleData } from './locales';


export const useLocaleData = () => {
	const sessionStore = useSessionStore();
	const localeData = computed(() => getLocaleData(sessionStore.locale));
	const directionLTR = computed(() => localeData.value.direction === 'ltr');
	return { localeData, directionLTR }
}
